export default __webpack_public_path__ + "static/media/il.a51a4775.png";